import * as inventoryRuleset from './inventory.ruleset';
import { inventorySchema } from './inventory.schema';
import { inventoryModifiers } from './inventory.modifiers';
import { inventoryGetters } from './inventory.getters';
import { inventoryMessages } from './inventory.messages';
import { inventoryActions } from './inventory.actions';
import { Immutable, SB } from '@play-co/replicant';
import { inventoryScheduledActions } from './inventory.scheduledActions';
import * as petRuleset from '../pet/pet.ruleset';
import { petSchema } from '../pet/pet.schema';
import { ReplicantModuleState } from '../../utils';

namespace Pet {
  export const ruleset = petRuleset;
  export const schema = petSchema(Pet);

  type State = Immutable<SB.ExtractType<SB.ObjectSchema<typeof schema>>>;
  export const getters = ({ pet }: State) => ({
    getCurrentEvolution: () => [...pet.evolutions].pop(),
  });
}

export type GemsExchangeRateConfig = {
  readonly items: number;
  readonly bonus: number;
  readonly premium: number;
};

export type Inventory = typeof Inventory;
// eslint-disable-next-line no-redeclare
export namespace Inventory {
  // TODO
  // This dependency only exists to get the species asset for the energy full
  // chatbot message. We should pass this param in and remove the dependency
  // but this will need to be a staggered rollout to consume old scheduled
  // actions that don't have the new payload param
  export const $DEPENDENCIES = { Pet };

  export const ruleset = inventoryRuleset;
  export const schema = inventorySchema;
  export const getters = inventoryGetters({ ruleset });
  export const modifiers = inventoryModifiers({ ruleset, getters });
  export const messages = inventoryMessages(
    { schema, modifiers },
    $DEPENDENCIES,
  );
  export const scheduledActions = inventoryScheduledActions(
    Inventory,
    $DEPENDENCIES,
  );
  export const actions = inventoryActions(Inventory);

  export type MutableState = ReplicantModuleState<Inventory>;
  export type State = Immutable<MutableState>;
}
